<template>
  <div class="m-grid m-grid--hor m-grid--root m-page">
    <AppHeader />

    <!-- begin::Body -->
    <div class="m-grid__item m-grid__item--fluid m-grid m-grid--ver-desktop m-grid--desktop m-body">
      <LeftMenu />

      <div
        v-if="hasActivePropertyServiceStatus"
        class="m-grid__item m-grid__item--fluid m-wrapper"
      >
        <div class="m-content">
          <div class="row">
            <div class="col-xl-12">
              <div
                class="m-portlet m-portlet--rounded m-portlet--head-sm fullable-portlet"
                :m-portlet="'true'"
              >
                <div class="m-portlet__head">
                  <div class="m-portlet__head-caption">
                    <div class="m-portlet__head-title">
                      <span class="m-portlet__head-icon">
                        <i class="flaticon-diagram m--font-brand m--icon-font-size-lg2 mt-n1" />
                      </span>
                      <h3 class="m-portlet__head-text">
                        {{ $t('menus.main.analytics') }}{{ $t('Property.headingSuffix') }}
                      </h3>
                    </div>
                  </div>
                  <div class="m-portlet__head-tools">
                    <ul class="m-portlet__nav">
                      <li class="m-portlet__nav-item">
                        <a
                          href="javascript:"
                          :m-portlet-tool="'fullscreen'"
                          data-trigger="hover"
                          class="m-portlet__nav-link m-portlet__nav-link--icon"
                        ><i class="la la-expand" /></a>
                      </li>
                    </ul>
                  </div>
                </div>

                <div class="m-portlet__body m-form">
                  <div
                    id="search"
                    class=""
                  >
                    <form
                      id="filterForm"
                      class="m-form--label-align-left- m-form--state-"
                      @submit.prevent="startSearch"
                    >
                      <div id="metrics">
                        <div
                          id="DateFilter"
                          class="row"
                        >
                          <div class="col-6">
                            <div class="form-group">
                              <div class="m-form_label">
                                <label
                                  for="FromDate"
                                  class="control-label"
                                >{{ $t('Property.Analytics.From') }}:</label>
                              </div>
                              <input
                                id="FromDate"
                                v-model="params.FromDate"
                                type="date"
                                class="form-control m-input  m-input--solid"
                                name="DateFilter.FromDate"
                                :placeholder="$t('Property.Analytics.From')"
                                required
                                min="2016-04-01"
                              >
                            </div>
                          </div>
                          <div class="col-6">
                            <div class="form-group">
                              <div class="m-form_label">
                                <label
                                  for="ToDate"
                                  class="control-label"
                                >{{ $t('Property.Analytics.To') }}:</label>
                              </div>
                              <input
                                id="ToDate"
                                v-model="params.ToDate"
                                type="date"
                                class="form-control m-input  m-input--solid"
                                name="DateFilter.ToDate"
                                required
                                :placeholder="$t('Property.Analytics.To')"
                              >
                            </div>
                          </div>
                          <div class="col-12">
                            <button
                              type="submit"
                              class="btn btn-sm btn-brand m-btn m-btn--custom m-btn--icon btn-block-sm mb-1"
                            >
                              <span>
                                <i class="la la-search" />
                                <span>{{ $t('common.ApplyFilters') }}</span>
                              </span>
                            </button>

                            <a
                              id="filtersBtn"
                              class="btn btn-metal btn-sm m-btn m-btn--custom m-btn--icon btn more-options collapsed btn-block-sm  mb-1"
                              role="button"
                              data-toggle="collapse"
                              href="#more-filters"
                              aria-expanded="false"
                              aria-controls="more-filters"
                            >
                              <i class="flaticon-interface-6 m--icon-font-size-sm2 d-inline pr-2" />
                              <span
                                id="moreFiltersSpan"
                                class="d-inline moreFiltersSpan"
                              >{{ $t('Property.Analytics.Morefilters') }}</span>
                            </a>
                          </div>
                        </div>
                        <div
                          id="more-filters"
                          class="row collapse pt-4"
                        >
                          <div class=" m-separator mb-3 m-separator--md" />
                          <div
                            id="propertyFilter"
                            class="col-lg-6"
                          >
                            <div class="row">
                              <div class="col-12">
                                <div class=" row ">
                                  <label
                                    class="col-xl-12 col-form-label"
                                    for="offer"
                                  >
                                    {{ $t('Directory.table.offertype') }}:
                                  </label>
                                  <div class="col-xl-12">
                                    <select
                                      id="offer"
                                      v-model.number="params.Offer"
                                      class="custom-select form-control m-input--solid"
                                      name="PropertyFilter.Offer"
                                    >
                                      <option value="0">
                                        {{ $t('offertype.Any') }}
                                      </option>
                                      <option value="3">
                                        {{ $t('offertype.for-sale') }}
                                      </option>
                                      <option value="4">
                                        {{ $t('offertype.for-rent') }}
                                      </option>
                                      <option value="2">
                                        {{ $t('offertype.for-holidays') }}
                                      </option>
                                    </select>
                                  </div>
                                </div>
                              </div>

                              <div class="col-12">
                                <div class=" row ">
                                  <label
                                    class="col-xl-12 col-form-label"
                                    for="typesLabel"
                                  >
                                    {{ $t('Property.Analytics.type') }}: <span class="m-form__help"> ({{ $t('common.multipleSelection') }})</span>
                                  </label>
                                  <div class="col-xl-12">
                                    <v-select
                                      v-model="params.Types"
                                      :options="propertyTypes"
                                      multiple
                                      :reduce="t => t.Id"
                                      :get-option-label="t => t.Labels[userLang]"
                                      :placeholder="$t('common.select')"
                                      class="custom-select form-control m-input--solid noclose"
                                    />
                                  </div>
                                </div>
                              </div>
                              <div class="col-12">
                                <div class=" row ">
                                  <label
                                    class="col-xl-12 col-form-label"
                                    for="id"
                                  >
                                    {{ $t('Property.Analytics.PropertyId') }}:
                                  </label>
                                  <div class="col-xl-12">
                                    <input
                                      id="id"
                                      v-model="params.Id"
                                      type="text"
                                      class="form-control m-input  m-input--solid"
                                      name="PropertyFilter.Id"
                                      :placeholder="$t('Property.Analytics.PropertyId')"
                                    >
                                  </div>
                                </div>
                              </div>
                              <div class="col-12">
                                <div class=" row ">
                                  <label
                                    class="col-xl-12 col-form-label"
                                    for="agentref"
                                  >
                                    {{ $t('Property.Analytics.agentRef') }}:
                                  </label>
                                  <div class="col-xl-12">
                                    <input
                                      id="agentref"
                                      v-model="params.AgentRef"
                                      type="text"
                                      class="form-control m-input  m-input--solid"
                                      name="PropertyFilter.AgentRef"
                                      :placeholder="$t('Property.Analytics.agentRef')"
                                    >
                                  </div>
                                </div>
                              </div>
                              <div class="col-12">
                                <div class=" row ">
                                  <label
                                    class="col-xl-12 col-form-label"
                                    for="minPrice"
                                  >
                                    {{ $t('Property.Analytics.minprice') }}:
                                  </label>
                                  <div class="col-xl-12">
                                    <input
                                      id="minPrice"
                                      v-model.number="params.MinPrice"
                                      type="number"
                                      class="form-control m-input  m-input--solid"
                                      name="PropertyFilter.MinPrice"
                                      :placeholder="$t('common.Eg')+' 100000'"
                                    >
                                  </div>
                                </div>
                              </div>
                              <div class="col-12">
                                <div class=" row ">
                                  <label
                                    class="col-xl-12 col-form-label"
                                    for="maxPrice"
                                  >
                                    {{ $t('Property.Analytics.maxprice') }}:
                                  </label>
                                  <div class="col-xl-12">
                                    <input
                                      id="maxPrice"
                                      v-model.number="params.MaxPrice"
                                      type="number"
                                      class="form-control m-input  m-input--solid"
                                      name="PropertyFilter.MaxPrice"
                                      :placeholder="$t('common.Eg')+' 250000'"
                                    >
                                  </div>
                                </div>
                              </div>
                              <div class="col-12">
                                <div class=" row ">
                                  <label
                                    class="col-xl-12 col-form-label"
                                    for="bedrooms"
                                  >
                                    {{ $t('Property.Analytics.bedrooms') }}:
                                  </label>
                                  <div class="col-xl-12">
                                    <select
                                      id="bedrooms"
                                      v-model="params.Bedrooms"
                                      name="PropertyFilter.Bedrooms"
                                      class="custom-select form-control m-input--solid"
                                    >
                                      <option value="">
                                        {{ $t('Property.Analytics.Any') }}
                                      </option>
                                      <option value="1">
                                        1
                                      </option>
                                      <option value="1+">
                                        1+
                                      </option>
                                      <option value="2">
                                        2
                                      </option>
                                      <option value="2+">
                                        2+
                                      </option>
                                      <option value="3">
                                        3
                                      </option>
                                      <option value="3+">
                                        3+
                                      </option>
                                      <option value="4">
                                        4
                                      </option>
                                      <option value="4+">
                                        4+
                                      </option>
                                      <option value="5">
                                        5
                                      </option>
                                      <option value="5+">
                                        5+
                                      </option>
                                    </select>
                                  </div>
                                </div>
                              </div>
                              <div class="col-12">
                                <div class=" row ">
                                  <label
                                    class="col-xl-12 col-form-label"
                                    for="bathrooms"
                                  >
                                    {{ $t('Property.Analytics.bathrooms') }}:
                                  </label>
                                  <div class="col-xl-12">
                                    <select
                                      id="bathrooms"
                                      v-model="params.Bathrooms"
                                      name="PropertyFilter.Bathrooms"
                                      class="custom-select form-control m-input--solid"
                                    >
                                      <option value="">
                                        {{ $t('Property.Analytics.Any') }}
                                      </option>
                                      <option value="1">
                                        1
                                      </option>
                                      <option value="1+">
                                        1+
                                      </option>
                                      <option value="2">
                                        2
                                      </option>
                                      <option value="2+">
                                        2+
                                      </option>
                                      <option value="3">
                                        3
                                      </option>
                                      <option value="3+">
                                        3+
                                      </option>
                                      <option value="4">
                                        4
                                      </option>
                                      <option value="4+">
                                        4+
                                      </option>
                                      <option value="5">
                                        5
                                      </option>
                                      <option value="5+">
                                        5+
                                      </option>
                                    </select>
                                  </div>
                                </div>
                              </div>
                              <div class="col-12">
                                <div class=" row ">
                                  <label class="col-xl-12 col-form-label">
                                    {{ $t('Property.Analytics.location') }}:
                                  </label>
                                  <div class="col-xl-12">
                                    <div class="input-group d-inline-flex">
                                      <v-select
                                        v-model="params.Location"
                                        :reduce="loc => `${loc.Type}:${loc.ID}`"
                                        :filterable="false"
                                        :options="suggestedLocations"
                                        :get-option-label="option => option.DisplayName"
                                        :placeholder="$t('Property.Analytics.location')"
                                        class="custom-select form-control m-input--solid noclose"
                                        @search="suggestLocations"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            id="viewFilter"
                            class="col-lg-6"
                          >
                            <div class="row">
                              <div class="col-12">
                                <div class=" row ">
                                  <label
                                    class="col-xl-12 col-form-label"
                                    for="languageLabel"
                                  >
                                    {{ $t('Property.Analytics.language') }}:
                                  </label>
                                  <div class="col-xl-12">
                                    <select
                                      id="language"
                                      v-model="params.Language"
                                      name="Language"
                                      class="custom-select form-control m-input--solid"
                                    >
                                      <option
                                        v-for="language in languages"
                                        :key="language.code"
                                        :value="language.code"
                                      >
                                        {{ language.name }}
                                      </option>
                                    </select>
                                  </div>
                                </div>
                              </div>

                              <div class="col-12">
                                <div class=" row ">
                                  <label
                                    class="col-xl-12 col-form-label"
                                    for="device"
                                  >
                                    {{ $t('Property.Analytics.VisitorsDevice') }}:
                                  </label>
                                  <div class="col-xl-12">
                                    <select
                                      id="device"
                                      v-model="params.Device"
                                      name="viewFilter.device"
                                      class="custom-select form-control m-input--solid"
                                    >
                                      <option value="">
                                        {{ $t('Property.Analytics.Any') }}
                                      </option>
                                      <option value="mobile">
                                        {{ $t('devices.mobile') }}
                                      </option>
                                      <option value="tablet">
                                        {{ $t('devices.tablet') }}
                                      </option>
                                      <option value="desktop">
                                        {{ $t('devices.desktop') }}
                                      </option>
                                      <option value="smarttv">
                                        {{ $t('devices.smarttv') }}
                                      </option>
                                      <option value="robot">
                                        {{ $t('devices.bot') }}
                                      </option>
                                    </select>
                                  </div>
                                </div>
                              </div>

                              <div class="col-12">
                                <div class=" row ">
                                  <label
                                    class="col-xl-12 col-form-label"
                                    for="country"
                                  >
                                    {{ $t('Property.Analytics.VisitorsCountry') }}:
                                  </label>
                                  <div class="col-xl-12">
                                    <select
                                      id="country"
                                      v-model="params.Country"
                                      name="Country"
                                      class="custom-select form-control m-input--solid"
                                    >
                                      <option
                                        v-for="country in countries"
                                        :key="country.code"
                                        :value="country.code"
                                      >
                                        {{ country.name }}
                                      </option>
                                    </select>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-12">
                            <div class="form-group">
                              <div class="mt-3">
                                <button
                                  type="submit"
                                  class="btn btn-sm btn-brand m-btn m-btn--custom m-btn--icon btn-block-sm"
                                >
                                  <span>
                                    <i class="la la-search" />
                                    <span>{{ $t('common.ApplyFilters') }}</span>
                                  </span>
                                </button>
                                <a
                                  class="btn btn-sm btn-metal m-btn m-btn--custom m-btn--icon btn more-options collapsed"
                                  role="button"
                                  data-toggle="collapse"
                                  href="#more-filters"
                                  aria-expanded="false"
                                  aria-controls="more-filters"
                                >
                                  <i class="flaticon-interface-6 m--icon-font-size-sm2 d-inline pr-2" />
                                  <span class="d-inline">{{ $t('Property.Analytics.Hidefilters') }}</span>
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-lg-12">
                            <div class=" m-separator my-3 m-separator--md" />
                          </div>
                        </div>
                        <div class="row">
                          <div
                            id="metricSelection"
                            class="col-12"
                          >
                            <div class="form-inline">
                              <label
                                for="metric1"
                                class="control-label mr-2"
                              >{{ $t('Property.Analytics.ViewMetric') }}: </label>
                              <select
                                id="metric1"
                                v-model="params.Metric"
                                class="custom-select form-control m-input--solid"
                                @change="changedMetrics"
                              >
                                <option
                                  v-for="metric in metrics"
                                  :key="metric.value"
                                  :value="metric.value"
                                >
                                  {{ metric.text }}
                                </option>
                              </select>
                              <label
                                for="metric2"
                                class="control-label mx-2"
                              >vs</label>
                              <select
                                id="metric2"
                                v-model="params.Metric2"
                                class="custom-select form-control m-input--solid"
                                @change="changedMetrics"
                              >
                                <option
                                  v-for="metric in metrics"
                                  :key="metric.value"
                                  :value="metric.value"
                                >
                                  {{ metric.text }}
                                </option>
                              </select>
                              <label
                                for="interval"
                                class="control-label mx-2"
                              >{{ $t('Property.Analytics.By') }}</label>
                              <select
                                id="interval"
                                v-model="params.Interval"
                                class="custom-select form-control m-input--solid"
                                name="IntervalSelection.Interval"
                                @change="changedInterval"
                              >
                                <option
                                  v-for="interval in intervals"
                                  :key="interval.value"
                                  :value="interval.value"
                                >
                                  {{ interval.text }}
                                </option>
                              </select>
                            </div>
                          </div>
                        </div>

                        <hr>
                        <div class="row">
                          <div class="col-5">
                            <div class="panel-heading">
                              <h3 class="panel-title">
                                {{ $t('Property.Analytics.Metrics') }}
                              </h3>
                            </div>
                          </div>
                          <div class="col-7">
                            <a
                              class="pull-right"
                              style="cursor:pointer"
                              @click.prevent.stop="exportData"
                            >
                              <span>
                                <i class="la la-download" />
                                <span>{{ $t('common.ExportToExcel') }}</span>
                              </span>
                            </a>
                          </div>
                          <div class="col-lg-12">
                            <div class="panel panel-default">
                              <div class="panel-body">
                                <div
                                  id="PropertyChart"
                                  :ref="'chart'"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        id="dimentions"
                        class="row"
                      >
                        <div class="col-lg-12">
                          <div class="panel panel-default">
                            <div class="panel-heading">
                              <h3 class="panel-title my-5">
                                {{ $t('Property.Analytics.Dimensions') }}
                              </h3>
                            </div>
                            <div class="panel-body">
                              <div class="form-inline">
                                <label
                                  for="dimension"
                                  class="control-label mr-2"
                                >{{ $t('Property.Analytics.SelectDimension') }}:</label>
                                <select
                                  id="dimension"
                                  v-model="params.Dimention"
                                  class="custom-select form-control m-input--solid"
                                  @change="changedDimensions"
                                >
                                  <option value="property">
                                    {{ $t('Property.Analytics.Id') }}
                                  </option>
                                  <option value="agentref">
                                    {{ $t('Property.Analytics.agentRef') }}
                                  </option>
                                  <option value="status">
                                    {{ $t('Property.Analytics.status') }}
                                  </option>
                                  <option value="type">
                                    {{ $t('Property.Analytics.type') }}
                                  </option>
                                  <option value="bedrooms">
                                    {{ $t('Property.Analytics.bedrooms') }}
                                  </option>
                                  <option value="bathrooms">
                                    {{ $t('Property.Analytics.bathrooms') }}
                                  </option>
                                  <option value="price">
                                    {{ $t('Property.Analytics.price') }}
                                  </option>
                                  <option value="province">
                                    {{ $t('Property.Analytics.province') }}
                                  </option>
                                  <option value="region">
                                    {{ $t('Property.Analytics.region') }}
                                  </option>
                                  <option value="town">
                                    {{ $t('Property.Analytics.town') }}
                                  </option>
                                  <option
                                    value="language"
                                    selected
                                  >
                                    {{ $t('Property.Analytics.language') }}
                                  </option>
                                  <option value="device">
                                    {{ $t('Property.Analytics.VisitorsDevice') }}
                                  </option>
                                  <option value="country">
                                    {{ $t('Property.Analytics.VisitorsCountry') }}
                                  </option>
                                </select>
                              </div>
                              <br>
                              <input type="hidden">
                              <div class="table-responsive">
                                <table
                                  id="PropertyTableDim"
                                  class="table table-striped table-bordered with-header-border not-responsive not-collapse"
                                  style="border: 2px solid #e6e7eb !important"
                                >
                                  <thead>
                                    <tr>
                                      <th rowspan="3" />
                                      <th colspan="2" />
                                      <th
                                        v-if="countOfNoOfPropertiesMetrics < 2"
                                        :colspan="6 - (countOfNoOfPropertiesMetrics * 3)"
                                      >
                                        thinkSPAIN
                                      </th>
                                    </tr>
                                    <tr>
                                      <th colspan="2">
                                        {{ $t('Property.table.totals') }}
                                      </th>
                                      <th
                                        v-if="countOfNoOfPropertiesMetrics < 2"
                                        :colspan="2 - countOfNoOfPropertiesMetrics"
                                      >
                                        {{ $t('Property.table.standard') }}
                                      </th>
                                      <th
                                        v-if="countOfNoOfPropertiesMetrics < 2"
                                        :colspan="2 - countOfNoOfPropertiesMetrics"
                                      >
                                        {{ $t('Property.table.featured') }}
                                      </th>
                                      <th
                                        v-if="countOfNoOfPropertiesMetrics < 2"
                                        :colspan="2 - countOfNoOfPropertiesMetrics"
                                      >
                                        {{ $t('Property.table.premium') }}
                                      </th>
                                    </tr>
                                    <tr>
                                      <th>{{ $t('homepage.stats.'+params.Metric) }}</th>
                                      <th>{{ $t('homepage.stats.'+params.Metric2) }}</th>

                                      <th v-if="searchParams.Metric !== 'noofproperties'">
                                        {{ $t('homepage.stats.'+params.Metric) }}
                                      </th>
                                      <th v-if="searchParams.Metric2 !== 'noofproperties'">
                                        {{ $t('homepage.stats.'+params.Metric2) }}
                                      </th>

                                      <th v-if="searchParams.Metric !== 'noofproperties'">
                                        {{ $t('homepage.stats.'+params.Metric) }}
                                      </th>
                                      <th v-if="searchParams.Metric2 !== 'noofproperties'">
                                        {{ $t('homepage.stats.'+params.Metric2) }}
                                      </th>

                                      <th v-if="searchParams.Metric !== 'noofproperties'">
                                        {{ $t('homepage.stats.'+params.Metric) }}
                                      </th>
                                      <th v-if="searchParams.Metric2 !== 'noofproperties'">
                                        {{ $t('homepage.stats.'+params.Metric2) }}
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <template v-if="rows.length==0">
                                      <tr>
                                        <td
                                          colspan="11"
                                          class="text-center m--regular-font-size-lg3 py-3"
                                        >
                                          {{ $t("Dashboard.noresults") }}
                                        </td>
                                      </tr>
                                    </template>
                                    <template v-else>
                                      <tr
                                        v-if="dimensionTotals"
                                        class="font-weight-bold"
                                      >
                                        <td class="ws-nowrap">
                                          {{ $t('Property.table.totals') }}
                                        </td>
                                        <td v-if="searchParams.Metric !== 'noofproperties'">
                                          {{ dimensionTotals.thinkspain.Standard.Metric1 + dimensionTotals.thinkspain.Featured.Metric1 + dimensionTotals.thinkspain.Premium.Metric1 }}
                                        </td>
                                        <td v-if="searchParams.Metric === 'noofproperties'">
                                          {{ dimensionTotals.NoOfProperties.Metric1 }}
                                        </td>
                                        <td v-if="searchParams.Metric2 !== 'noofproperties'">
                                          {{ dimensionTotals.thinkspain.Standard.Metric2 + dimensionTotals.thinkspain.Featured.Metric2 + dimensionTotals.thinkspain.Premium.Metric2 }}
                                        </td>
                                        <td v-if="searchParams.Metric2 === 'noofproperties'">
                                          {{ dimensionTotals.NoOfProperties.Metric2 }}
                                        </td>
                                        <td v-if="searchParams.Metric !== 'noofproperties'">
                                          {{ dimensionTotals.thinkspain.Standard.Metric1 }}
                                        </td>
                                        <td v-if="searchParams.Metric2 !== 'noofproperties'">
                                          {{ dimensionTotals.thinkspain.Standard.Metric2 }}
                                        </td>
                                        <td v-if="searchParams.Metric !== 'noofproperties'">
                                          {{ dimensionTotals.thinkspain.Featured.Metric1 }}
                                        </td>
                                        <td v-if="searchParams.Metric2 !== 'noofproperties'">
                                          {{ dimensionTotals.thinkspain.Featured.Metric2 }}
                                        </td>
                                        <td v-if="searchParams.Metric !== 'noofproperties'">
                                          {{ dimensionTotals.thinkspain.Premium.Metric1 }}
                                        </td>
                                        <td v-if="searchParams.Metric2 !== 'noofproperties'">
                                          {{ dimensionTotals.thinkspain.Premium.Metric2 }}
                                        </td>
                                      </tr>
                                      <tr
                                        v-for="(row, index) in pagedRows"
                                        :key="row.Group || index"
                                      >
                                        <td
                                          v-if="searchParams.Dimention === 'property'"
                                          class="ws-nowrap m--font-bolder"
                                        >
                                          <a
                                            :id="'propertyInfo_' + row.Group"
                                            href="javascript:;"
                                            @click.stop.prevent="openPropertyPopup(row.Group, $event)"
                                          >
                                            {{ row.GroupDescription ? row.GroupDescription : row.Group }}
                                          </a>
                                        </td>
                                        <td
                                          v-else-if="searchParams.Dimention === 'agentref'"
                                          :id="'propertyHistory_' + row.Group"
                                          class="ws-nowrap m--font-bolder"
                                        >
                                          <a
                                            href="javascript:;"
                                            @click.stop.prevent="openPropertyHistory(row.Group, $event)"
                                          >
                                            {{ row.GroupDescription ? row.GroupDescription : row.Group }}
                                          </a>
                                        </td>
                                        <td
                                          v-else
                                          class="ws-nowrap m--font-bolder"
                                        >
                                          {{ row.GroupDescription ? row.GroupDescription : row.Group }}
                                        </td>
                                        <td v-if="searchParams.Metric !== 'noofproperties'">
                                          {{ row.thinkspain.Standard.Metric1 + row.thinkspain.Featured.Metric1 + row.thinkspain.Premium.Metric1 }}
                                        </td>
                                        <td v-if="searchParams.Metric === 'noofproperties'">
                                          {{ row.NoOfProperties.Metric1 }}
                                        </td>
                                        <td v-if="searchParams.Metric2 !== 'noofproperties'">
                                          {{ row.thinkspain.Standard.Metric2 + row.thinkspain.Featured.Metric2 + row.thinkspain.Premium.Metric2 }}
                                        </td>
                                        <td v-if="searchParams.Metric2 === 'noofproperties'">
                                          {{ row.NoOfProperties.Metric2 }}
                                        </td>
                                        <td v-if="searchParams.Metric !== 'noofproperties'">
                                          {{ row.thinkspain.Standard.Metric1 }}
                                        </td>
                                        <td v-if="searchParams.Metric2 !== 'noofproperties'">
                                          {{ row.thinkspain.Standard.Metric2 }}
                                        </td>
                                        <td v-if="searchParams.Metric !== 'noofproperties'">
                                          {{ row.thinkspain.Featured.Metric1 }}
                                        </td>
                                        <td v-if="searchParams.Metric2 !== 'noofproperties'">
                                          {{ row.thinkspain.Featured.Metric2 }}
                                        </td>
                                        <td v-if="searchParams.Metric !== 'noofproperties'">
                                          {{ row.thinkspain.Premium.Metric1 }}
                                        </td>
                                        <td v-if="searchParams.Metric2 !== 'noofproperties'">
                                          {{ row.thinkspain.Premium.Metric2 }}
                                        </td>
                                      </tr>
                                    </template>
                                  </tbody>
                                </table>
                              </div>
                              <Pagination
                                :total-pages="pagination.totalPages"
                                :total="pagination.totalResults || 0"
                                :per-page="pagination.Take"
                                :loading="false"
                                :current-page="pagination.currentPage"
                                :target-scroll-y="'dimension'"
                                @pagechanged="onPageChange"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <template v-if="propertyService && !hasActivePropertyServiceStatus">
        <NoPropertyServices />
      </template>
    </div>
    <!-- end:: Body -->

    <!-- BEGIN: Footer -->
    <AppFooter />
    <!-- END: Footer -->

    <!-- BEGIN::Property Info Popover -->
    <div
      id="popoverInfo"
      class="d-none"
    >
      <div
        v-if="selectedProperty"
        class="row"
      >
        <div class="col-4 pr-0">
          <div class="thumbnailTableContainer">
            <div class="ratio-4-3-padding">
              <a
                :href="getPropertyURL"
                target="_blank"
              >

                <div class="d-none broken-img">
                  <span class="img-cont">
                    <i class="la la-warning m--icon-font-size-lg3 d-block" />
                    <span class="d-block small">{{ $t('common.BrokenImages') }}</span>
                  </span>
                </div>

                <img
                  ref="propertyInfoImage"
                  width="100%"
                  alt=""
                  :src="getFirstPhotoUrl"
                  data-img="false"
                >
              </a>
            </div>
          </div>
        </div>
        <div class="col">
          <h6>
            <a
              :href="getPropertyURL"
              target="_blank"
            >
              {{ $t(selectedProperty.Type.Term) }} {{ selectedProperty.Town.Labels.Default }} ({{ selectedProperty.Town.Labels.province.Default }})
            </a>
          </h6>
          <p v-if="selectedProperty.PriceInEuro">
            {{ $utils.formatCurrency(selectedProperty.PriceInEuro) }} EUR
          </p>
          <p v-if="selectedProperty.PriceInPounds">
            {{ $utils.formatCurrency(selectedProperty.PriceInPounds) }} GBP
          </p>
        </div>
        <div class="clearfix" />
      </div>
    </div>

    <div
      id="propertyhistory"
      class="d-none"
    >
      <div
        v-for="(property, index) in propertyhistory"
        :key="index"
        class="row"
      >
        <div class="col-4 pr-0">
          <a
            :href="thinkspainURL + '/' + userLang + '/redirect-to-property/' + property.Id"
            target="_blank"
            class="d-block"
          >{{ property.Id }}</a>
        </div>
        <div class="col">
          <h6>{{ $t('Property.Analytics.From') + ': ' + formatToDate(property.FromDate) }}</h6>
          <h6>{{ $t('Property.Analytics.To') + ': ' + formatToDate(property.ToDate) }}</h6>
          <p>{{ $utils.formatCurrency(property.Price) }} {{ property.Currency }} </p>
        </div>
        <div class="clearfix" />
      </div>
      <div
        v-if="!propertyhistory || propertyhistory.length === 0"
        class="row text-center"
      >
        <div class="col">
          {{ $t('Property.Analytics.NoHistoryFound') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppHeader from '../../common/Header.vue';
import AppFooter from '../../common/Footer.vue';
import LeftMenu from '../../common/menus/LeftMenu.vue';
import NoPropertyServices from '../../services/Property.vue';
import { clientapi } from '../../../../api-clients/client-api.js';
import { clientanalyticsapi } from '../../../../api-clients/client-analytics-api.js';
import data from '../../../../data.js';
import vSelect from 'vue-select';
import Pagination from '../../common/Pagination.vue';
import { getUser, getPropertyService, onBeforeOpenSwal } from '../../../../functions.ts';
import locationapi from '../../../../api-clients/location-api.js';
import dayjs from 'dayjs';

export default {
    components: {
        AppFooter,
        AppHeader,
        LeftMenu,
        Pagination,
        vSelect,
        NoPropertyServices,
    },
    data() {
        return {
            user: {},
            propertyService: null,
            countries: {},
            languages: {},
            metrics: [
                { value: 'views',
                    text: this.$t( 'homepage.stats.TotalViews' ) },
                { value: 'search',
                    text: this.$t( 'homepage.stats.SearchResultViews' ) },
                { value: 'detailed',
                    text: this.$t( 'homepage.stats.DetailedViews' ) },
                { value: 'enquiries',
                    text: this.$t( 'homepage.stats.Enquiries' ) },
                {
                    value: 'noofproperties',
                    text: this.$t( 'homepage.stats.NumbPropertiesListed' ),
                },
            ],
            intervals: [
                { value: 'day',
                    text: this.$t( 'Property.Analytics.Day' ) },
                { value: 'week',
                    text: this.$t( 'Property.Analytics.Week' ) },
                { value: 'month',
                    text: this.$t( 'Property.Analytics.Month' ) },
            ],
            selectedProperty: null,
            propertyhistory: null,
            showPropInfo: false,
            propertyInfo: null,
            propertyInfoPhoto: null,
            dateText: this.$t( 'homepage.stats.Date' ),
            url: import.meta.env.TWC_API_URL,
            pagination: {
                Take: import.meta.env.TWC_TAKE_ROWS,
                Skip: 0,
                totalPages: 0,
                totalResults: 0,
                currentPage: 1,
            },
            resultsPerPage: 20,
            suggestedLocations: [],
            propertyTypes: [],
            selectedTypes: [],
            selectedLanguage: null,
            saw: null,
            locationOptions: [],
            thinkspainURL: import.meta.env.TWC_TS_URL,
            URL: import.meta.env.TWC_API_URL,
            range: 30,
            rows: [],
            dimensionTotals: null,
            params: {
                FromDate: dayjs().tz().subtract( 30, 'days' ).format( 'YYYY-MM-DD' ),
                ToDate: dayjs().tz().subtract( 1, 'days' ).format( 'YYYY-MM-DD' ),
                Dimention: 'language',
                Metric: 'views',
                Metric2: 'enquiries',
                Interval: 'day',
                Offer: 0,
                Types: null,
                Id: '',
                AgentRef: '',
                MinPrice: null,
                MaxPrice: null,
                Bathrooms: '',
                Bedrooms: '',
                Location: null,
                Language: '',
                Device: '',
                Country: '',
            },
            searchParams: {},
            chartData: {},
            chartOptions: {},
        };
    },
    computed: {
        countOfNoOfPropertiesMetrics() {
            let count = 0;
            if ( this.searchParams.Metric === 'noofproperties' ) {
                count++;
            }

            if ( this.searchParams.Metric2 === 'noofproperties' ) {
                count++;
            }

            return count;
        },
        getPropertyId() {
            if ( this.propertyInfo !== null ) {
                return this.propertyInfo.Id;
            }

            return 'xx';
        },
        getPropertyURL() {
            if ( this.selectedProperty !== null ) {
                return (
                    this.thinkspainURL +
          '/' +
          this.userLang +
          '/redirect-to-property/' +
          this.selectedProperty.Id
                );
            }

            return '';
        },
        getFirstPhotoUrl() {
            let property = this.selectedProperty;

            let photos = property.Photos.filter( ( p ) => p.CdnUrl );

            if ( !photos || photos.length === 0 ) {
                return null;
            }

            let photo = photos[ 0 ];

            for ( let p of photos ) {
                if ( p.Number < photo.Number ) {
                    photo = p;
                }
            }

            let urlChunks = photo.CdnUrl.split( '/' );

            if ( urlChunks.length < 3 ) {
                return '';
            }

            urlChunks.splice( urlChunks.length - 1, 0, 's400x300' );

            return urlChunks.join( '/' );
        },
        pagedRows() {
            if ( !Array.isArray( this.rows ) || this.rows.length === 0 ) {
                return [];
            }

            const page = Math.max( 1, this.pagination.currentPage || 1 );
            const start = ( page - 1 ) * this.resultsPerPage;
            return this.rows.slice( start, start + this.resultsPerPage );
        },
        hasActivePropertyServiceStatus() {
            if ( !this.propertyService ) {
                return false;
            }

            let allowedStatuses = [
                'ACTIVE',
                'ACTIVE_FUTURE',
                'ACTIVE_EXPIRED',
                'ACTIVE_PENDING',
                'ACTIVE_SUSPENDED',
            ];
            return allowedStatuses.includes( this.propertyService.Status );
        },
        userLang() {
            return this.$i18n.locale;
        },
    },
    watch: {
        '$route.query': {
            handler: function( newquery, oldquery ) {
                if ( !this.hasActivePropertyServiceStatus ) {
                    return;
                }

                // check which query param changed (newQuery vs oldQuery)
                let changedParams = [];

                let newQuery = this.getParamsFromRouteQuery( newquery );
                let oldQuery = this.getParamsFromRouteQuery( oldquery );

                // Check if each parameter in the new query has changed (or was empty or same as default)
                for ( let param in newQuery ) {
                    if ( JSON.stringify( newQuery[ param ] ) !== JSON.stringify( oldQuery[ param ] ) ) {
                        changedParams.push( param );
                    }
                }

                // Check if each parameter in the new query has changed
                for ( let param in oldQuery ) {
                    if ( JSON.stringify( oldQuery[ param ] ) !== JSON.stringify( newQuery[ param ] ) ) {
                        if ( !changedParams.includes( param ) ) {
                            changedParams.push( param );
                        }
                    }
                }

                this.updateParamsFromRoute();
                this.searchParams = JSON.parse( JSON.stringify( this.params ) );

                const onlySkipChanged = changedParams.length === 1 && changedParams.includes( 'Skip' );
                if ( onlySkipChanged ) {
                    const desiredSkip = this.searchParams.Skip || 0;
                    const desiredPage = Math.floor( desiredSkip / this.resultsPerPage ) + 1;
                    this.pagination.currentPage = Math.max( 1, desiredPage );
                    this.pagination.Skip = desiredSkip;
                    this.params.Skip = desiredSkip;
                    return;
                }

                const dimensionOnlyChanged = changedParams.length === 1 && changedParams.includes( 'Dimention' );
                const dimensionAndSkip = changedParams.length === 2 && changedParams.includes( 'Dimention' ) && changedParams.includes( 'Skip' );

                if ( dimensionOnlyChanged || dimensionAndSkip ) {
                    this.queryDimensions();
                    return;
                }

                let intervalOnly = changedParams.length === 1 && changedParams.includes( 'Interval' );

                if ( intervalOnly ) {
                    this.queryMetrics();
                    return;
                }

                this.queryDimensions();
                this.queryMetrics();
            },
            immediate: false,
        },
    },
    unmounted() {
        window.removeEventListener( 'resize', this.reDrawChart );
    },
    async created() {
        window.addEventListener( 'resize', this.reDrawChart );

        this.user = getUser();
        this.propertyService = await getPropertyService();

        let byName = function( c1, c2 ) {
            var name1 = c1.name.toUpperCase();
            var name2 = c2.name.toUpperCase();
            if ( name1 < name2 ) {
                return -1;
            }
            if ( name1 > name2 ) {
                return 1;
            }
            return 0;
        };

        let lang = this.userLang;

        let listOfCounries = data
            .countries()
            .map( ( country ) => {
                return { code: country.Code,
                    name: country.Labels[ lang ] };
            } )
            .sort( byName );
        listOfCounries.unshift( { code: '',
            name: this.$t( 'common.select' ) } );
        this.countries = listOfCounries;

        let listOfLanguages = data
            .languages()
            .map( ( language ) => {
                return { code: language.code,
                    name: language.Labels[ lang ] };
            } )
            .sort( byName );
        listOfLanguages.unshift( { code: '',
            name: this.$t( 'common.select' ) } );
        this.languages = listOfLanguages;

        this.propertyTypes = data.propertyTypes();

        this.updateParamsFromRoute();

        if ( this.hasActivePropertyServiceStatus ) {
            this.loadExternalScripts();
            this.setUpHideShowFilters();
        }
    },
    methods: {
        getDefaultParams() {
            return {
                FromDate: dayjs().tz().subtract( 30, 'days' ).format( 'YYYY-MM-DD' ),
                ToDate: dayjs().tz().subtract( 1, 'days' ).format( 'YYYY-MM-DD' ),
                Dimention: 'language',
                Metric: 'views',
                Metric2: 'enquiries',
                Interval: 'day',
                Offer: 0,
                Types: '',
                Id: '',
                AgentRef: '',
                MinPrice: null,
                MaxPrice: null,
                Bathrooms: '',
                Bedrooms: '',
                Location: '',
                Language: '',
                Device: '',
                Country: '',
                Skip: 0,
            };
        },
        async updateParamsFromRoute() {
            let params = this.getParamsFromRouteQuery( this.$route.query );

            if ( params.Location ) {
                let result = await locationapi.get( `/location/${params.Location}` );
                if ( result.status !== 200 ) {
                    swal( { title: this.$t( 'common.Error' ),
                        text: this.$t( 'common.SomethingWentWrong' ),
                        type: 'error' } );
                    return;
                }
                this.suggestedLocations = [ result.data ];
            }

            this.params = params;
        },
        getParamsFromRouteQuery( query ) {
            let params = {};

            let defaultParams = this.getDefaultParams();

            params.FromDate = query.fromdate || defaultParams.FromDate;
            params.ToDate = query.todate || defaultParams.ToDate;
            params.Dimention = query.dimention || defaultParams.Dimention;
            params.Metric = query.metric || defaultParams.Metric;
            params.Metric2 = query.metric2 || defaultParams.Metric2;
            params.Interval = query.interval || defaultParams.Interval;
            params.Offer = query.offer || defaultParams.Offer;

            let types = [];

            // convert query.types to array of ints
            if ( query.types ) {
                if ( Array.isArray( query.types ) ) {
                    types = query.types.map( ( t ) => parseInt( t ) );
                } else {
                    types = [ parseInt( query.types ) ];
                }
            }

            params.Types = types || defaultParams.Types;
            params.Id = query.id || defaultParams.Id;
            params.AgentRef = query.agentref || defaultParams.AgentRef;

            if ( query.minprice ) {
                params.MinPrice = parseInt( query.minprice );
            } else {
                params.MinPrice = defaultParams.MinPrice;
            }

            if ( query.maxprice ) {
                params.MaxPrice = parseInt( query.maxprice );
            } else {
                params.MaxPrice = defaultParams.MaxPrice;
            }

            if ( query.skip ) {
                params.Skip = parseInt( query.skip );
            } else {
                params.Skip = defaultParams.Skip;
            }

            params.Bathrooms = query.bathrooms || defaultParams.Bathrooms;
            params.Bedrooms = query.bedrooms || defaultParams.Bedrooms;
            params.Location = query.location || defaultParams.Location;
            params.Language = query.language || defaultParams.Language;
            params.Device = query.device || defaultParams.Device;
            params.Country = query.country || defaultParams.Country;

            return params;
        },
        updateRouteFromParams() {
            let defaultParams = this.getDefaultParams();

            let newRouteParams = {
                fromdate: this.params.FromDate,
                todate: this.params.ToDate,
            };

            if ( this.params.Dimention !== defaultParams.Dimention ) {
                newRouteParams.dimention = this.params.Dimention;
            }

            if ( this.params.Metric !== defaultParams.Metric ) {
                newRouteParams.metric = this.params.Metric;
            }

            if ( this.params.Metric2 !== defaultParams.Metric2 ) {
                newRouteParams.metric2 = this.params.Metric2;
            }

            if ( this.params.Interval !== defaultParams.Interval ) {
                newRouteParams.interval = this.params.Interval;
            }

            if ( this.params.Offer !== defaultParams.Offer ) {
                newRouteParams.offer = this.params.Offer;
            }

            if ( this.params.Types !== defaultParams.Types ) {
                newRouteParams.types = this.params.Types;
            }

            if ( this.params.Id !== defaultParams.Id ) {
                newRouteParams.id = this.params.Id;
            }

            if ( this.params.AgentRef !== defaultParams.AgentRef ) {
                newRouteParams.agentref = this.params.AgentRef;
            }

            if ( this.params.MinPrice !== defaultParams.MinPrice ) {
                newRouteParams.minprice = this.params.MinPrice;
            }

            if ( this.params.MaxPrice !== defaultParams.MaxPrice ) {
                newRouteParams.maxprice = this.params.MaxPrice;
            }

            if ( this.params.Bathrooms !== defaultParams.Bathrooms ) {
                newRouteParams.bathrooms = this.params.Bathrooms;
            }

            if ( this.params.Bedrooms !== defaultParams.Bedrooms ) {
                newRouteParams.bedrooms = this.params.Bedrooms;
            }

            if ( this.params.Location !== defaultParams.Location ) {
                newRouteParams.location = this.params.Location;
            }

            if ( this.params.Language !== defaultParams.Language ) {
                newRouteParams.language = this.params.Language;
            }

            if ( this.params.Device !== defaultParams.Device ) {
                newRouteParams.device = this.params.Device;
            }

            if ( this.params.Country !== defaultParams.Country ) {
                newRouteParams.country = this.params.Country;
            }

            if ( this.params.Skip !== defaultParams.Skip ) {
                newRouteParams.skip = this.params.Skip;
            }

            if ( JSON.stringify( this.$route.query ) !== JSON.stringify( newRouteParams ) ) {
                this.$router.push( { query: newRouteParams } );
            }
        },
        formatToDate( input ) {
            return dayjs( input ).tz().format( 'DD/MM/YYYY' );
        },
        async openPropertyPopup( propertyId, event ) {
            mApp.block( event.target, null );
            let propertyResponse = await clientapi.get( '/property/' + propertyId );
            mApp.unblock( event.target );

            if ( propertyResponse.status !== 200 ) {
                swal( {
                    html: this.$t( 'error.ServerError.text' ),
                    type: 'error',
                    confirmButtonClass: 'btn btn-brand m-btn m-btn--wide',
                    onBeforeOpen: () => {
                        onBeforeOpenSwal();
                    },
                } );
                return;
            }

            this.selectedProperty = propertyResponse.data;

            await this.$nextTick();

            let myPopover = $( event.target ).popover( {
                title:
          'Ref: ' +
          this.selectedProperty.AgentRef +
          '<span class="close-popover float-right text-dark"><i class=" la la-close "></i></span>',
                placement: 'auto',
                content: document.getElementById( 'popoverInfo' ).innerHTML,
                html: true,
            } );

            myPopover.popover( 'show' );

            myPopover.on( 'shown.bs.popover', function() {
                let popupcontent = document.getElementById(
                    event.target.getAttribute( 'aria-describedby' ),
                );
                if ( !popupcontent ) {
                    return;
                }
                let closeBtn = popupcontent.querySelector( '.close-popover' );
                if ( !closeBtn ) {
                    return;
                }

                closeBtn.addEventListener( 'click', function() {
                    myPopover.popover( 'dispose' );
                } );
            } );
        },
        async openPropertyHistory( agentRef, event ) {
            $( '.popover.show' ).popover( 'hide' );

            mApp.block( event.target, null );
            let propertyResponse = await clientanalyticsapi.post( '/propertyhistory', { Login: this.user.Login,
                AgentRef: agentRef,
                FromDate: dayjs( this.searchParams.FromDate ).tz().format(),
                ToDate: dayjs( this.searchParams.ToDate ).tz().format() } );
            mApp.unblock( event.target );

            if ( propertyResponse.status !== 200 ) {
                swal( {
                    title: this.$t( 'error.ServerError.text' ),
                    type: 'error',
                    confirmButtonClass: 'btn btn-brand m-btn m-btn--wide',
                    onBeforeOpen: () => {
                        onBeforeOpenSwal();
                    },
                } );
                return;
            }

            this.propertyhistory = propertyResponse.data;

            await this.$nextTick();

            let myPopover = $( event.target ).popover( {
                title:
          'Ref: ' +
          agentRef +
          '<span class="close-popover float-right text-dark"><i class=" la la-close "></i></span>',
                placement: 'auto',
                content: document.getElementById( 'propertyhistory' ).innerHTML,
                html: true,
            } );

            myPopover.popover( 'show' );

            myPopover.on( 'shown.bs.popover', function() {
                let popupcontent = document.getElementById(
                    event.target.getAttribute( 'aria-describedby' ),
                );
                if ( !popupcontent ) {
                    return;
                }
                let closeBtn = popupcontent.querySelector( '.close-popover' );
                if ( !closeBtn ) {
                    return;
                }

                closeBtn.addEventListener( 'click', function() {
                    myPopover.popover( 'dispose' );
                } );
            } );
        },
        suggestLocations( search, loading ) {
            if ( search.length <= 2 ) {
                return;
            }
            loading( true );
            locationapi
                .get( '/location', {
                    params: { freetext: search,
                        lang: this.$i18n.locale },
                } )
                .then( ( result ) => {
                    if ( result.status === 200 ) {
                        this.suggestedLocations = result.data;
                    }
                    loading( false );
                } );
        },
        setUpHideShowFilters() {
            let vueThis = this;

            let form = document.getElementById( 'filterForm' );
            let $form = $( form );

            let moreFiltersSpans = document.querySelector( '.moreFiltersSpan' );

            $form.on( 'hide.bs.collapse', function() {
                moreFiltersSpans.innerHTML = vueThis.$t(
                    'Property.Analytics.MoreFilters',
                );
            } );
            $form.on( 'show.bs.collapse', function() {
                moreFiltersSpans.innerHTML = vueThis.$t(
                    'Property.Analytics.Hidefilters',
                );
            } );
        },
        loadExternalScripts() {
            let component = this;
            let googleChartScripts = document.createElement( 'script' );
            googleChartScripts.onload = () => {
                component.externalScriptsLoaded();
            };
            googleChartScripts.setAttribute(
                'src',
                'https://www.gstatic.com/charts/loader.js',
            );
            document.head.appendChild( googleChartScripts );
        },
        externalScriptsLoaded() {
            let component = this;
            google.charts.load( 'current', { packages: [ 'corechart', 'line' ] } );
            google.charts.setOnLoadCallback( function() {
                component.search();
            } );
        },
        onPageChange( page ) {
            this.pagination.currentPage = page;
            this.pagination.Skip =
        ( this.pagination.currentPage - 1 ) * this.pagination.Take;
            this.params.Skip = this.pagination.Skip;

            this.updateRouteFromParams();
        },
        changedMetrics() {
            this.updateRouteFromParams();
        },
        changedDimensions() {
            this.pagination.currentPage = 1;
            this.pagination.Skip = 0;
            this.params.Skip = 0;
            this.updateRouteFromParams();
        },
        changedInterval() {
            this.updateRouteFromParams();
        },
        startSearch() {
            this.params.Skip = 0;
            this.updateRouteFromParams();
        },
        search() {
            this.searchParams = JSON.parse( JSON.stringify( this.params ) );

            this.queryMetrics();
            this.queryDimensions();
        },
        async exportData() {
            let request = {
                filter: this.getFilter(),
                language: this.$i18n.locale,
                metrics: [ this.searchParams.Metric, this.searchParams.Metric2 ],
                dimention: this.searchParams.Dimention,
                interval: this.searchParams.Interval,
            };

            this.chartLoading( true );
            this.dimensionLoading( true );

            let exportResult = await clientanalyticsapi.post( '/property/export', request, { responseType: 'blob' } );

            if ( exportResult.status !== 200 ) {
                this.chartLoading( false );
                this.dimensionLoading( false );
                swal( {
                    title: this.$t( 'error.AnErrorOccurred' ),
                    type: 'error',
                    confirmButtonClass: 'btn btn-brand m-btn m-btn--wide',
                    onBeforeOpen: () => {
                        onBeforeOpenSwal();
                    },
                } );
                return;
            }

            this.chartLoading( false );
            this.dimensionLoading( false );

            let blob = await exportResult.data;

            const url = window.URL.createObjectURL( blob );
            const link = document.createElement( 'a' );
            link.href = url;
            link.setAttribute( 'download', 'propertyanalytics.xlsx' ); // or any other extension
            document.body.appendChild( link );
            link.click();
        },

        getFilter() {
            let filter = {
                datefilter: {
                    fromDate: this.searchParams.FromDate,
                    toDate: this.searchParams.ToDate,
                },
                propertyFilter: {
                    types: this.searchParams.Types,
                    id: this.searchParams.Id,
                    agentRef: this.searchParams.AgentRef,
                    minPrice: this.searchParams.MinPrice,
                    maxPrice: this.searchParams.MaxPrice,
                    location: this.searchParams.Location,
                },
                viewFilter: {
                    language: this.searchParams.Language,
                    device: this.searchParams.Device,
                    country: this.searchParams.Country,
                    source: 'thinkspain', // based on #CCP-505 we are no longer going to support EOS
                },
            };

            filter.propertyFilter.login = this.user.Login;

            if ( this.searchParams.Offer.length > 0 ) {
                filter.propertyFilter.offer = parseInt( this.searchParams.Offer );
            }

            // bedrooms can be 2, 3 ... or 3+ so we need to break it to bedrooms and minbedrooms parameters
            if ( this.searchParams.Bedrooms.length > 0 ) {
                if ( this.searchParams.Bedrooms.endsWith( '+' ) ) {
                    filter.propertyFilter.minBedrooms = parseInt( this.searchParams.Bedrooms.replace( '+', '' ) );
                } else {
                    filter.propertyFilter.bedrooms = parseInt( this.searchParams.Bedrooms );
                }
            }

            // same with bathrooms
            if ( this.searchParams.Bathrooms.length > 0 ) {
                if ( this.searchParams.Bathrooms.endsWith( '+' ) ) {
                    filter.propertyFilter.minBathrooms = parseInt( this.searchParams.Bathrooms.replace( '+', '' ) );
                } else {
                    filter.propertyFilter.bathrooms = parseInt( this.searchParams.Bathrooms );
                }
            }
            return filter;
        },
        async queryMetrics() {
            let metricsRequest = {
                metric: this.searchParams.Metric,
                interval: this.searchParams.Interval,
                filter: this.getFilter(),
            };

            this.chartLoading( true );

            let queryMetric1 = clientanalyticsapi.post( '/property/metrics', metricsRequest );

            let metrics2Request = JSON.parse( JSON.stringify( metricsRequest ) );
            metrics2Request.metric = this.searchParams.Metric2;

            let queryMetric2 = clientanalyticsapi.post( '/property/metrics', metrics2Request );

            let resultMetric1 = await queryMetric1;
            let resultMetric2 = await queryMetric2;

            this.chartLoading( false );

            if ( resultMetric1.status !== 200 || resultMetric2.status !== 200 ) {
                swal( {
                    title: this.$t( 'error.AnErrorOccurred' ),
                    type: 'error',
                    confirmButtonClass: 'btn btn-brand m-btn m-btn--wide',
                    onBeforeOpen: () => {
                        onBeforeOpenSwal();
                    },
                } );
                return;
            }

            this.drawChart( resultMetric1.data, resultMetric2.data );
        },
        reDrawChart() {
            let chartElement = document.getElementById( 'PropertyChart' );

            if ( !chartElement ) {
                return;
            }
            if ( this.chartData && this.chartOptions ) {
                let chart = new google.visualization.AreaChart( chartElement );
                chart.draw( this.chartData, this.chartOptions );
            }
        },
        drawChart( metric1result, metric2result ) {
            let myChart = new google.visualization.DataTable();

            let title1 = this.$t( 'homepage.stats.' + this.searchParams.Metric );
            let title2 = this.$t( 'homepage.stats.' + this.searchParams.Metric2 );

            myChart.addColumn( 'string', this.dateText );
            myChart.addColumn( 'number', title1 );
            myChart.addColumn( 'number', title2 );

            let chartElement = document.getElementById( 'PropertyChart' );

            if ( !chartElement ) {
                return;
            }

            let metric1Max = 0;
            let metric2Max = 0;

            metric1result.forEach( ( el, index ) => {
                if ( el.Metric > metric1Max ) {
                    metric1Max = el.Metric;
                }

                let metric2Value = metric2result[ index ].Metric;

                if ( metric2Value > metric2Max ) {
                    metric2Max = metric2Value;
                }

                myChart.addRow( [
                    dayjs( el.Date ).tz().format( 'DD MMM YYYY' ),
                    el.Metric,
                    metric2Value,
                ] );
            } );

            let options = {
                enableInteractivity: true,
                colors: [ '#4382ce', '#f4516c' ],
                legend: 'top',
                width: '100%',
                title: null,
                fontSize: '12',
                italic: false,
                series: {
                    0: {
                        targetAxisIndex: 0,
                        textStyle: {
                            color: '#000',
                            fontSize: '12',
                            italic: false,
                        },
                        italic: false,
                    },
                    1: {
                        targetAxisIndex: 1,
                        textStyle: {
                            color: '#000',
                            fontSize: '12',
                            italic: false,
                        },
                        italic: false,
                    },
                },
                tooltip: {
                    trigger: 'hover',
                },
                vAxes: {
                    0: {
                        italic: false,
                        title: title1,
                        textStyle: {
                            color: '#4382ce',
                            fontSize: '12',
                            italic: false,
                        },
                        viewWindow: {
                            min: 0,
                            max: metric1Max + 2,
                        },
                    },
                    1: {
                        italic: false,
                        title: title2,
                        textStyle: {
                            color: '#f4516c',
                            fontSize: '12',
                            italic: false,
                        },
                        viewWindow: {
                            min: 0,
                            max: metric2Max + 2,
                        },
                    },
                },
                vAxis: {
                    viewWindowMode: 'explicit',
                    format: '0',
                    italic: false,
                    textStyle: {
                        color: '#000',
                        fontSize: '12',
                        italic: false,
                    },
                    title: {
                        color: '#000',
                        fontSize: '12',
                        italic: false,
                    },
                },
                hAxis: {
                    italic: false,
                    textStyle: {
                        color: '#000',
                        fontSize: '12',
                        italic: false,
                    },
                    title: {
                        color: '#000',
                        fontSize: '12',
                        italic: false,
                    },
                },
            };

            this.chartData = myChart;
            this.chartOptions = options;

            let chart = new google.visualization.AreaChart( chartElement );
            chart.draw( myChart, options );
        },
        async queryDimensions() {
            $( '.popover.show' ).popover( 'destroy' );

            this.dimensionLoading( true );

            const [ resultDimetion1, resultDimetion2 ] = await Promise.all( [
                this.fetchAllDimensionResults( this.searchParams.Metric ),
                this.fetchAllDimensionResults( this.searchParams.Metric2 ),
            ] );

            this.dimensionLoading( false );

            if ( !resultDimetion1 || !resultDimetion2 ) {
                swal( {
                    title: this.$t( 'error.AnErrorOccurred' ),
                    type: 'error',
                    confirmButtonClass: 'btn btn-brand m-btn m-btn--wide',
                    onBeforeOpen: () => {
                        onBeforeOpenSwal();
                    },
                } );
                return;
            }

            this.setTableData( resultDimetion1, resultDimetion2 );
        },
        setTableData( result1Dimention, result2Dimention ) {
            const toNumber = ( value ) => {
                const numeric = Number( value );
                return Number.isFinite( numeric ) ? numeric : 0;
            };

            let rows = [];

            let defaultNoOfProperties = 0;

            if ( [ 'country', 'device', 'language' ].includes( this.searchParams.Dimention ) ) {
                defaultNoOfProperties = 'N/A';
            }

            for ( let group of result1Dimention.Groups || [] ) {
                let row = {
                    Group: group.Group,
                    NoOfProperties: { Metric1: defaultNoOfProperties,
                        Metric2: defaultNoOfProperties },
                    thinkspain: {
                        Standard: { Metric1: 0,
                            Metric2: 0 },
                        Featured: { Metric1: 0,
                            Metric2: 0 },
                        Premium: { Metric1: 0,
                            Metric2: 0 },
                    },
                };

                for ( let result of group.MetricResults ) {
                    let eventName = result.EventName;

                    if ( eventName === 'noofproperties' ) {
                        row.NoOfProperties.Metric1 = toNumber( result.Total );
                    } else if ( eventName.endsWith( 'featured-premium' ) ) {
                        row[ result.Source ].Premium.Metric1 += toNumber( result.Total );
                    } else if ( eventName.endsWith( 'featured' ) ) {
                        row[ result.Source ].Featured.Metric1 += toNumber( result.Total );
                    } else {
                        row[ result.Source ].Standard.Metric1 += toNumber( result.Total );
                    }
                }
                rows.push( row );
            }

            for ( let group of result2Dimention.Groups || [] ) {
                let row = {};
                for ( let existing of rows ) {
                    if ( existing.Group === group.Group ) {
                        row = existing;
                        break;
                    }
                }

                if ( !row.Group ) {
                    continue;
                }

                for ( let result of group.MetricResults ) {
                    let eventName = result.EventName;

                    if ( eventName === 'noofproperties' ) {
                        row.NoOfProperties.Metric2 = toNumber( result.Total );
                    } else if ( eventName.endsWith( 'featured-premium' ) ) {
                        row[ result.Source ].Premium.Metric2 += toNumber( result.Total );
                    } else if ( eventName.endsWith( 'featured' ) ) {
                        row[ result.Source ].Featured.Metric2 += toNumber( result.Total );
                    } else {
                        row[ result.Source ].Standard.Metric2 += toNumber( result.Total );
                    }
                }
            }

            // populate row with some more descriptive info
            for ( let row of rows ) {
                switch ( this.searchParams.Dimention ) {
                case 'language': {
                    row.GroupDescription = this.$t( 'language.' + row.Group );
                    break;
                }
                case 'device': {
                    row.GroupDescription = this.$t( 'devices.' + row.Group );
                    break;
                }
                case 'status': {
                    row.GroupDescription = this.$t( 'offertype.' + row.Group );
                    break;
                }
                case 'type': {
                    row.GroupDescription = this.$t( 'property.type.' + row.Group );
                    break;
                }
                case 'country': {
                    for ( let country of this.countries ) {
                        if ( country.code.toUpperCase() === row.Group.toUpperCase() ) {
                            row.GroupDescription = country.name;
                            break;
                        }
                    }
                    break;
                }
                default:
                    row.GroupDescription = row.Group;
                    break;
                }
            }

            // sort results by group
            if ( [ 'country' ].includes( this.searchParams.Dimention ) ) {
                rows.sort( ( a, b ) => ( a.GroupDescription > b.GroupDescription ) ? 1 : -1 );
            }

            const totals = rows.reduce( ( acc, row ) => {
                acc.NoOfProperties.Metric1 += toNumber( row.NoOfProperties.Metric1 );
                acc.NoOfProperties.Metric2 += toNumber( row.NoOfProperties.Metric2 );

                acc.thinkspain.Standard.Metric1 += toNumber( row.thinkspain.Standard.Metric1 );
                acc.thinkspain.Standard.Metric2 += toNumber( row.thinkspain.Standard.Metric2 );

                acc.thinkspain.Featured.Metric1 += toNumber( row.thinkspain.Featured.Metric1 );
                acc.thinkspain.Featured.Metric2 += toNumber( row.thinkspain.Featured.Metric2 );

                acc.thinkspain.Premium.Metric1 += toNumber( row.thinkspain.Premium.Metric1 );
                acc.thinkspain.Premium.Metric2 += toNumber( row.thinkspain.Premium.Metric2 );

                return acc;
            }, {
                NoOfProperties: { Metric1: 0,
                    Metric2: 0 },
                thinkspain: {
                    Standard: { Metric1: 0,
                        Metric2: 0 },
                    Featured: { Metric1: 0,
                        Metric2: 0 },
                    Premium: { Metric1: 0,
                        Metric2: 0 },
                },
            } );

            this.rows = rows;
            this.dimensionTotals = rows.length ? totals : null;

            const totalResults = rows.length;
            const totalPages = totalResults > 0 ? Math.ceil( totalResults / this.resultsPerPage ) : 0;
            const requestedSkip = this.searchParams.Skip || 0;
            let currentPage = totalResults > 0 ? Math.floor( requestedSkip / this.resultsPerPage ) + 1 : 1;

            if ( totalPages > 0 ) {
                currentPage = Math.max( 1, Math.min( currentPage, totalPages ) );
            } else {
                currentPage = 1;
            }

            this.pagination.totalResults = totalResults;
            this.pagination.totalPages = totalPages;
            this.pagination.Take = this.resultsPerPage;
            this.pagination.currentPage = currentPage;
            this.pagination.Skip = totalResults > 0 ? ( currentPage - 1 ) * this.resultsPerPage : 0;

            this.params.Skip = this.pagination.Skip;
            this.searchParams.Skip = this.pagination.Skip;
        },
        async fetchAllDimensionResults( metric ) {
            const pageSize = 500;
            let skip = 0;
            let allGroups = [];
            let total = 0;
            let iterations = 0;

            while ( true ) {
                iterations += 1;
                if ( iterations > 200 ) {
                    console.warn( 'Stopping dimension fetch due to iteration guard' );
                    break;
                }

                const request = {
                    metric,
                    dimention: this.searchParams.Dimention,
                    take: pageSize,
                    skip,
                    filter: this.getFilter(),
                };

                const response = await clientanalyticsapi.post( '/property/dimentions', request );

                if ( response.status !== 200 ) {
                    return null;
                }

                const data = response.data || {};

                if ( Array.isArray( data.Groups ) && data.Groups.length > 0 ) {
                    allGroups = allGroups.concat( data.Groups );
                }

                if ( typeof data.Total === 'number' ) {
                    total = data.Total;
                }

                const fetchedCount = Array.isArray( data.Groups ) ? data.Groups.length : 0;

                if ( fetchedCount < pageSize ) {
                    break;
                }

                skip += pageSize;

                if ( total && skip >= total ) {
                    break;
                }
            }

            return {
                Groups: allGroups,
                Total: total || allGroups.length,
                Page: 1,
            };
        },
        chartLoading( block ) {
            if ( block ) {
                mApp.block( '#metrics', {
                    message: this.$t( 'common.LoadingDataPleaseWait' ),
                } );
            } else {
                mApp.unblock( '#metrics' );
            }
        },
        dimensionLoading( block ) {
            let vueThis = this;
            if ( block ) {
                mApp.block( '#dimentions', {
                    message: vueThis.$t( 'common.LoadingDataPleaseWait' ),
                } );
            } else {
                mApp.unblock( '#dimentions' );
            }
        },
    },
};
</script>
